<template>
    <KnowledgeBaseContent/>
</template>
<script>
import KnowledgeBaseContent from './KnowledgeBaseContent.vue'
export default {
    name: 'KnowledgeBaseComponent',
    components: {
        KnowledgeBaseContent
    }
}
</script>
